// What a wellness-recall row's button does, and what it says it will do.
//
// The row already reports its state with a "task started" chip — deliberately
// worded not to claim the patient has been spoken to. What it lacked was a way
// to reach the task it had just made.

export interface RecallRow {
  status?: string;
  taskId?: string | null;
  patientPhone?: string | null;
}

export interface RecallRowState {
  action: 'open-task' | 'start' | 'blocked';
  hint: string;
}

/**
 * Precedence matters: an existing task wins over a missing phone. The task is
 * already on the board and has to stay reachable, even for a patient whose
 * number was removed afterwards.
 */
export function describeRecallRow(row: RecallRow): RecallRowState {
  if (row.taskId) {
    return {
      action: 'open-task',
      hint: 'Open the scheduling task for this patient on the dashboard',
    };
  }
  if (!row.patientPhone) {
    return {
      action: 'blocked',
      hint: 'No phone number on file, so there is nobody to message',
    };
  }
  return {
    action: 'start',
    hint: 'Start scheduling — puts a task on the dashboard, sends nothing',
  };
}
